module.exports = __webpack_public_path__ + "img/r01.aa219138.png";